import CloseIcon from '@mui/icons-material/Close';
import { IconButton, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  onClick: () => void;
  dataAction?: string;
  disabled?: boolean;
}

export const DialogCloseButton: React.FC<IProps> = ({ onClick, dataAction = 'close_dialog', disabled }) => {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: theme.palette.action.active,
      }}
      data-action={dataAction}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};
